import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ChaseDetailStateService } from "../../../../platform/modules/member/chase-detail/chase-detail-state.service";
import { CalculatedGroupDirective } from "../calculated-group-component.model";
import { PpcService } from "../ppc.service";

@Component({
  selector: "form-delivery-group",
  templateUrl: "./delivery-group.component.html",
  styleUrls: [
    "../dates-between/dates-between.component.scss",
    "./delivery-group.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryGroupComponent extends CalculatedGroupDirective {
  constructor(
    ppcService: PpcService,
    changeDetector: ChangeDetectorRef,
    chaseDetailStateService: ChaseDetailStateService
  ) {
    super(ppcService, changeDetector, chaseDetailStateService);
  }


  get enrollmentPlus42Days(): Date {
    return this.ppc.enrollmentPlus42Days;
  }

  get hasEnrollmentPlus42Days(): boolean {
    return this.hasPpc && this.ppc.hasEnrollmentPlus42Days;
  }
}
